<template>
  <div class="date-time">
    <date-time-picker
      v-if="datetimeFrom"
      @input-timestamp="dateTime => (datetimeFrom = dateTime)"
      :init-date="datetimeFrom ? new Date(datetimeFrom) : new Date()"
      :init-time="datetimeFrom ? new Date(datetimeFrom) : new Date()"
      :datePlaceholder="$t('placeholder.date.from')"
      :timePlaceholder="$t('placeholder.time.from')"
      :flexDirection="configs.parameters['Time picker'] === 'right' ? 'row' : 'column'"
      :isShowTime="configs.parameters['Time picker'] === 'off' ? false : true"
      expanded
    ></date-time-picker>
    <date-time-picker
      v-if="datetimeTo"
      @input-timestamp="dateTime => (datetimeTo = dateTime)"
      :init-date="datetimeTo ? new Date(datetimeTo) : new Date()"
      :init-time="datetimeTo ? new Date(datetimeTo) : new Date()"
      :datePlaceholder="$t('placeholder.date.to')"
      :timePlaceholder="$t('placeholder.time.to')"
      :flexDirection="configs.parameters['Time picker'] === 'right' ? 'row' : 'column'"
      :isShowTime="configs.parameters['Time picker'] === 'off' ? false : true"
      expanded
    ></date-time-picker>
    <b-field class="apply">
      <edit-button :editOptions="['Apply']" @click="apply()">
        <template>
          <span class="text">{{ $t('button.apply') }}</span>
        </template>
      </edit-button>
    </b-field>
  </div>
</template>
<script>
import EditButton from '@/components/EditButton'
import DateTimePicker from '@/components/DateTimePicker'

export default {
  name: 'DashboardDateTime',
  components: {
    EditButton,
    DateTimePicker
  },
  props: {
    items: {
      type: Object,
      default() {
        return {}
      }
    },
    configs: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      datetimeFrom: null,
      datetimeTo: null
    }
  },
  mounted() {
    this.datetimeFrom = this.items.first_date * 1000
    this.datetimeTo = this.items.second_date * 1000
    this.$forceUpdate()
  },
  methods: {
    apply() {
      this.$emit('apply', { first_date: this.datetimeFrom / 1000, second_date: this.datetimeTo / 1000 })
    }
  }
}
</script>

<style lang="scss">
.date-time {
  width: 100%;
  height: 100%;
  .field {
    min-width: 100px;
    margin-bottom: -0.2rem;
  }
  .apply {
    justify-content: right;
    display: flex;
  }
}
</style>
